export const defaultHomeContent = {
  navigationLinks: [],
  hero: {},
  quoteSection: {},
  quoteOptions: {
    insuranceTypes: [],
    licensePlateRegions: [],
  },
  products: {
    eyebrow: '',
    heading: '',
    subheading: '',
    buttonText: '',
    items: [],
  },
  whyChoose: {
    eyebrow: '',
    heading: '',
    reasons: [],
  },
  stats: {
    items: [],
  },
  benefits: {
    eyebrow: '',
    heading: '',
    items: [],
  },
  process: {
    eyebrow: '',
    heading: '',
    steps: [],
  },
  faqs: {
    eyebrow: '',
    heading: '',
    items: [],
  },
  testimonials: {
    eyebrow: '',
    heading: '',
    items: [],
  },
  mobileApp: {
    eyebrow: '',
    heading: '',
    appStoreText: '',
    googlePlayText: '',
    features: [],
  },
  news: {
    eyebrow: '',
    heading: '',
    buttonText: '',
    items: [],
  },
  partners: {
    heading: 'ĐỐI TÁC CỦA DBV',
    items: [
      { name: 'Toyota', logoKey: 'toyota' },
      { name: 'Honda', logoKey: 'honda' },
      { name: 'Ford', logoKey: 'ford' },
      { name: 'VinFast', logoKey: 'vin' },
      { name: 'Thaco', logoKey: 'thaco' },
      { name: 'Mitsubishi', logoKey: 'mitsubishi' },
      { name: 'MG', logoKey: 'mg' },
      { name: 'OMODA', logoKey: 'omoda' },
      { name: 'BYD', logoKey: 'byd' },
      { name: 'MEC', logoKey: 'mec' },
      { name: 'Lexus', logoKey: 'lexus' },
    ],
  },
  banner: {},
  contactSupport: {
    zaloUrl: 'https://zalo.me/0901234567',
    zaloLabel: 'Chat Zalo với tư vấn viên',
    mapEmbedUrl: 'https://www.google.com/maps?q=Quan+1,+Ho+Chi+Minh+City&z=15&output=embed',
    mapTitle: 'Bản đồ văn phòng DBV',
  },
  footer: {
    brandName: '',
    brandSubtitle: '',
    description: '',
    copyright: '',
    links: {},
    contacts: [],
  },
};
